(function () {
	'use strict';

	a3_pilot_reports.controller('MemoModalCtrl', MemoModalCtrl);

	/**
	* @memberof PilotReports
	* @ngdoc controller
	* @name MemoModalCtrl
	* @description 
	*  Manages the Memo Modal
	* @ngInject
	*/
	function MemoModalCtrl($scope, memo, $uibModalInstance, $sce, MemoImagesFactory) {
		$scope.memo = memo;
		$scope.cancel = cancel;
		$scope.hasCountry = false;
		$scope.hasFlightNo = false;
		$scope.hasAirport = false;
		$scope.hasRoute = false;
		$scope.hasAcType = false;
		$scope.hasZone = false;
		$scope.hasEuropean = false;
		$scope.hasSchengen = false;
		$scope.hasAcRegistration = false;
		$scope.hasSsrCode = false;
		$scope.hasTrainingIndicator = false;
		$scope.hasGroundDuties = false;
		$scope.hasNone = true;
		$scope.images = [];
		$scope.showImage = showImage;
		$scope.body = $sce.trustAsHtml(memo.Body);

		MemoImagesFactory.getMemoImagesByIndex(memo.Id, function (results) {
			$scope.images = results;
		});

		/**
		 * Open A new Tab and show the image 
		 * @memberof MemoModalCtrl
		 * @param {string} src Base64 endode string of Image
		 */
		function showImage(src) {
			var image = new Image();
			image.src = src;

			var w = window.open("");
			w.document.write(image.outerHTML);
		}

		/**
		 * Show the criteria of the memo 
		 * @memberof MemoModalCtrl
		 */
		(function changeFlags() {
			angular.forEach(memo.MemoCriteria, function (criteria) {
				if (criteria.Country || criteria.Type == "Country" && criteria.Field) {
					$scope.hasCountry = true;
					$scope.hasNone = false;
				}
				if (criteria.FlightNo || criteria.Type == "FlightNo" && criteria.Field) {
					$scope.hasFlightNo = true;
					$scope.hasNone = false;
				}
				if (criteria.Airport || criteria.Type == "Airport" && criteria.Field) {
					$scope.hasAirport = true;
					$scope.hasNone = false;
				}
				if (criteria.RouteStart || criteria.Type == "RouteStart" && criteria.Field) {
					$scope.hasRoute = true;
					$scope.hasNone = false;
				}
				if (criteria.AcType || criteria.Type == "AcType" && criteria.Field) {
					$scope.hasAcType = true;
					$scope.hasNone = false;
				}
				if (criteria.Zone || criteria.Type == "Zone" && criteria.Field) {
					$scope.hasZone = true;
					$scope.hasNone = false;
				}
				if (criteria.AcRegistration || criteria.Type == "AcRegistration" && criteria.Field) {
					$scope.hasAcRegistration = true;
					$scope.hasNone = false;
				}
				if (criteria.Type == "SsrCode" && criteria.Field) {
					$scope.hasSsrCode = true;
					$scope.hasNone = false;
				}
				if (criteria.Type == "TrainingId" && criteria.Field) {
					$scope.hasTrainingIndicator = true;
					$scope.hasNone = false;
				}
				if (criteria.Type == "European" && criteria.Field) {
					$scope.hasEuropean = true;
					$scope.hasNone = false;
				}
				if (criteria.Type == "Schengen" && criteria.Field) {
					$scope.hasSchengen = true;
					$scope.hasNone = false;
				}
				if (criteria.Type == "GroundDutyCode" && criteria.Field) {
					$scope.hasGroundDuties = true;
					$scope.hasNone = false;
				}
			})
		})();

		/**
		 * Close the modal
		 * @memberof MemoModalCtrl
		 */
		function cancel() {
			$uibModalInstance.close('close');
		}
	}
})();